import { createElement } from "react";
import React from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { deleteRouteListFilter, deleteVesselListFilter } from "./LocalStorage.js";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Colors_TorghattenBlueWithOpacity } from "./Design.js";
import { ErrorHandling_snackError } from "./ViewHelpers.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { Button, Typography, Paper } from "@mui/material";
import { ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";

export function Login() {
    let elems_3, elems_2, elems;
    const patternInput = reactApi.useState(undefined);
    useEffectOnce(() => {
        deleteVesselListFilter();
        deleteRouteListFilter();
    });
    return createElement("div", createObj(ofArray([["style", {
        height: 100 + "vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors_TorghattenBlueWithOpacity(0.7),
    }], (elems_3 = [ErrorHandling_snackError(patternInput[0], () => {
        patternInput[1](undefined);
    }), MuiHelpers_createElement(Paper, [["style", {
        width: 80 + "vw",
        maxWidth: 350,
        padding: 20,
        display: "flex",
        flexDirection: "column",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        borderRadius: 5,
    }], (elems = [createElement("img", {
        src: "/images/Torghatten_big_white_bg.png",
        style: {
            width: 100 + "%",
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), MuiHelpers_createElement(Typography, [["children", "IKT-SKIP"], ["style", {
        textAlign: "center",
        fontSize: 2.25 + "rem",
        color: "#0e2d7a",
        fontWeight: "bold",
        letterSpacing: 2,
        marginTop: -2.5 + "rem",
    }]]), MuiHelpers_createElement(Button, [["fullWidth", true], ["color", "primary"], ["size", "large"], ["variant", "contained"], ["children", reactApi.Children.toArray(["Logg inn via Microsoft"])], ["style", {
        textTransform: "none",
        marginTop: 10,
        backgroundColor: "#0e2d7a",
        color: "#FFFFFF",
    }], ["href", "/api/auth/signin"]])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

//# sourceMappingURL=Login.js.map
